import PropTypes from "prop-types";
import React from "react";
import template from "templates/modules/product_card.jinja";
import Baustein from "web/react/components/baustein/baustein";
import { ProductCardPropType } from "web/types/product-card";
import classnames from "classnames";
import styles from "./product-card.css";

import "web/script/components/product-card";


function ProductCard({ className, product, imageSize, hideOnDesktop }) {
    return (
        <Baustein
            className={classnames(styles.cardWrapper, className)}
            template={template}
            args={{
                product: product,
                imagesize: imageSize,
                hide_on_desktop: hideOnDesktop,
            }}
        />
    );
}

const imageSizeOptions = ["related", "feed"];

ProductCard.propTypes = {
    product: ProductCardPropType.isRequired,
    imageSize: PropTypes.oneOf(imageSizeOptions).isRequired,
    hideOnDesktop: PropTypes.bool,
    className: PropTypes.string,
};

export default ProductCard;

ProductCard.defaultProps = {
    imageSize: "related",
    hideOnDesktop: false,
};
